export default __webpack_public_path__ + "b35f20b.png";